<template>
  <form class="mx-auto col-sm-12" @submit.prevent>
    <div
      class="form-group col-lg-12"
      :class="{ 'has-error': errors.has('activeToLink') }"
    >
      <label for="activeToLink">{{ $t("active") }}</label>
      <input
        disabled
        type="text"
        id="activeToLink"
        name="activeToLink"
        class="form-control"
        :placeholder="$t('ph_active')"
        v-model="activeToLink"
        v-validate="'required'"
      />

      <small v-show="errors.has('activeToLink')" class="form-text">
        {{ errors.first("activeToLink") }}
      </small>
    </div>

    <div class="form-group col-lg-12">
      <label for="sim_card">{{ $t("sim_card") }}</label>
      <Combobox
        class="bg-white"
        :hasErrors="errors.has('sim_card')"
        name="sim_card"
        :placeholder="$t('select_a_item')"
        label="name"
        :options="simcards"
        :getOptionLabel="simcard => mountOptionLabel(simcard, 'SIMCARD', ['model.name', 'model.manufacturer.name', 'serie', 'fieldExtra1', 'fieldExtra2', 'fieldExtra3'])"
        :initial-value="simCard"
        v-model="simCard"
        :reduce="(simCard) => simCard.id"
        v-validate="'required'"
      />

      <small v-show="errors.has('sim_card')" class="form-text">
        {{ errors.first("sim_card") }}
      </small>
    </div>

    <div class="form-group">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "LinkActiveModelSimcard",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      activeToLink: undefined,
      simCard: undefined,
    };
  },

  props: {
    active: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState({
      simcards: (state) => state.active.allSimcard,
    }),
  },

  methods: {
    ...mapActions("active", ["linkActiveModelAndSimcard", "cleanState"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));
        this.$store.dispatch("notify/error", err);
        return;
      }

      const data = {
        activeToLink: this.active.id,
        simCard: this.simCard,
      };

      const result = await this.linkActiveModelAndSimcard(data);

      if (result) {
        return this.$router.push({ name: "listactives" });
      }
    },

    mountOptionLabel(data, firstInfo, paths) {
      const values = [firstInfo]

      for (const path of paths) {
        const value = _.get(data, path, false)

        value && values.push(value)
      }

      return values.join(' / ')
    },
  },

  async mounted() {
    const { dispatch } = this.$store;

    dispatch("overlay/show", true);

    await dispatch("active/fetchAllSimcard");

    if (this.active) {
      const { linked, activeTypeData } = this.active;

      this.activeToLink = this.mountOptionLabel(this.active, activeTypeData.name, ['model.manufacturer.name', 'model.name', 'serie', 'location'])
      this.simCard = linked ? linked.id : undefined;
    }

    dispatch("overlay/show", false);
  },

  destroyed() {
    this.$store.dispatch("active/cleanState");
  },
};
</script>
